export var actionTypePrefix = '@@EmoteSelector';
export var reduxKey = '@@EmoteSelector';
//# sourceMappingURL=constants.js.map